var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMorePathways = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.33,17.99c-3.27,0-6.06-2.11-7.08-5.04-.19-.55-.7-.92-1.28-.92h-.01c-.91,0-1.58,.89-1.28,1.75,1.37,4.02,5.18,6.91,9.66,6.91,.67,0,1.33-.07,1.97-.19,.91-.18,1.37-1.2,.91-2v-.02c-.3-.5-.87-.76-1.43-.65-.47,.09-.96,.14-1.45,.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.33,3.01c.57,0,1.13,.07,1.67,.19,.58,.13,1.18-.12,1.47-.63v-.02c.46-.77,.04-1.78-.82-1.98-.74-.17-1.52-.27-2.32-.27C5.68,.3,1.75,3.43,.53,7.68c-.25,.87,.39,1.73,1.29,1.73h.02c.6,0,1.13-.4,1.3-.98,.9-3.13,3.79-5.42,7.2-5.42Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.53,10.5c0-2.64-1.01-5.05-2.66-6.86-.61-.67-1.69-.53-2.14,.25h0c-.3,.52-.22,1.17,.18,1.61,1.19,1.33,1.92,3.08,1.92,5s-.79,3.82-2.08,5.17c-.42,.44-.52,1.11-.21,1.64h0c.44,.77,1.51,.91,2.13,.27,1.78-1.84,2.87-4.33,2.87-7.08Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMorePathways, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_Pathways.e7b91c13.svg";
export { ForwardRef as ReactComponent };